import React from 'react'
import { connect } from 'react-redux'
import { lifeSaver, lock, scroll } from '@starbucks-web/pattern-library/icons'
import { baseUrlSelector } from '../../../../../shared/app/state/selectors/locales.js'
import {
  customerServiceUrlSelector,
  privacyStatementUrlSelector,
  termsOfUseUrlSelector,
} from '../../../../../shared/app/state/selectors/privacy-and-terms.js'
import { accountsMessages } from '../../../../../shared/app/messages/index.js'
import SectionHeading from '../section-heading/index.jsx'
import AboutListItem from './about-list-item.jsx'
import messages from './messages.js'
import { isExternalLink } from '../../../../../shared/app/utils/is-external-link.js'

const HelpPoliciesSection = ({
  baseUrl,
  privacyStatementUrl,
  termsOfUseUrl,
  helpUrl,
}) => (
  <React.Fragment>
    <SectionHeading {...messages.aboutHeading} />
    <AboutListItem
      icon={lifeSaver}
      link={helpUrl}
      linkProps={{
        'data-e2e': 'helpLink',
      }}
      text={messages.helpLabel}
    />
    <AboutListItem
      icon={scroll}
      link={
        !isExternalLink(termsOfUseUrl)
          ? `${baseUrl}${termsOfUseUrl}`
          : termsOfUseUrl
      }
      linkProps={{
        'data-e2e': 'touLink',
      }}
      text={accountsMessages.termsOfUse}
    />
    <AboutListItem
      icon={lock}
      link={
        !isExternalLink(privacyStatementUrl)
          ? `${baseUrl}${privacyStatementUrl}`
          : privacyStatementUrl
      }
      linkProps={{
        'data-e2e': 'privacyLink',
      }}
      text={messages.privacyStatementLabel}
    />
  </React.Fragment>
)

const select = (state) => ({
  baseUrl: baseUrlSelector(state),
  helpUrl: customerServiceUrlSelector(state),
  privacyStatementUrl: privacyStatementUrlSelector(state),
  termsOfUseUrl: termsOfUseUrlSelector(state),
})

export default connect(select)(HelpPoliciesSection)
